import { render, staticRenderFns } from "./DeleteChildCategory.vue?vue&type=template&id=31479507&scoped=true&"
import script from "./DeleteChildCategory.vue?vue&type=script&lang=js&"
export * from "./DeleteChildCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31479507",
  null
  
)

export default component.exports